import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { operations } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export type OutgoingWebhookSource = NonNullable<
	NonNullable<
		operations["OutgoingWebhooksController_listDeliveries"]["parameters"]["query"]
	>["source"]
>;

export default function useOutgoingWebhookDeliveries(
	shopId: string,
	{
		page = 1,
		pageSize = 20,
		source,
	}: { page?: number; pageSize?: number; source?: OutgoingWebhookSource } = {},
) {
	return $api.useQuery("get", "/shops/{shopId}/outgoing-webhooks/deliveries", {
		params: { path: { shopId }, query: { page, pageSize, source } },
	});
}

export function useReactivateOutgoingWebhookEndpoint(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation<
		"post",
		"/shops/{shopId}/outgoing-webhooks/endpoints/reactivate",
		{ url: string }
	>("post", "/shops/{shopId}/outgoing-webhooks/endpoints/reactivate", {
		mapVariables: (body) => ({ params: { path: { shopId } }, body }),
		// The URL's health shows in the tracking and the return lists.
		invalidate: [
			() =>
				queryClient.invalidateQueries({
					queryKey: ["get", "/shops/{shopId}/workflow-webhooks"],
				}),
			() =>
				queryClient.invalidateQueries({
					queryKey: ["get", "/shops/{shopId}/return-workflow-webhooks"],
				}),
		],
	});
}
